import { useMemo, useState } from "react";
import { FiPlus, FiSearch, FiFilter } from "react-icons/fi";
import { useGetUsersQuery } from "./usersApiSlice";
import UserTable from "./components/UserTable";
import { useNavigate } from "react-router-dom";

export default function UsersPage() {
  const [query, setQuery] = useState("");
  const navigate = useNavigate();

  const handleNew = () => navigate(`/dash/users/new`)

  const { data: users = [], isLoading, isFetching } = useGetUsersQuery(query, {
    // skip: query.length < 0   // example if you want to delay fetch
  });

  const filtered = useMemo(() => {
    if (!query) return users;
    const q = query.toLowerCase();
    return users.filter(u =>
      (u.username || "").toLowerCase().includes(q) ||
      (u.email || "").toLowerCase().includes(q) ||
      (Array.isArray(u.roles) ? u.roles.join(",") : "").toLowerCase().includes(q)
    );
  }, [users, query]);

  return (
    <div className="min-h-full px-4 sm:px-6 lg:px-8 py-6">
      {/* Header */}
      <div className="flex items-center justify-between gap-4">
        <div>
          <h1 className="text-2xl font-semibold tracking-tight text-gray-900">Users</h1>
          <p className="text-sm text-gray-500">Manage access, roles, and account status.</p>
        </div>
        <button
          // onClick={() => setShowNew(true)}
          onClick={handleNew}
          className="inline-flex items-center gap-2 rounded-xl border border-gray-200 bg-white px-4 py-2 text-sm font-medium text-gray-900 hover:bg-gray-50 shadow-sm"
        >
          <FiPlus className="opacity-70" /> New User
        </button>
      </div>

      {/* Actions */}
      <div className="mt-4 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
        <div className="relative flex-1">
          <FiSearch className="absolute left-3 top-2.5 h-4 w-4 text-gray-400" />
          <input
            className="w-full rounded-xl border border-gray-200 bg-white py-2 pl-9 pr-3 text-sm text-gray-900 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-black/5"
            placeholder="Search users by name, email, or role…"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
          {isFetching && (
            <div className="absolute right-3 top-2.5 text-xs text-gray-400">loading…</div>
          )}
        </div>
        <button className="inline-flex items-center gap-2 rounded-xl border border-gray-200 bg-white px-3 py-2 text-sm text-gray-700 hover:bg-gray-50">
          <FiFilter /> Filters
        </button>
      </div>

      {/* Content */}
      <div className="mt-6">
        <UserTable users={filtered} loading={isLoading} />
      </div>
    </div>
  );
}
